import React from "react"
import styled from "styled-components"
import SEO from "../components/seo"
import { Link } from "gatsby"
import _ from "lodash"
import { useTranslation } from "react-i18next"
import Icon from "@mdi/react"
import { mdiEarth } from "@mdi/js"
import Pagination from "../components/Pagination"
import { Helmet } from "react-helmet"

const Container = styled.div`
  width: 66.6%;

  @media screen and (max-width: 415px) {
    width: 100%;
  }
`
const SupportPageList = styled.div`
  min-height: 500px;
  width: 100%;
  padding-right: 24px;
  float: left;
`

const SupportPageListItem = styled(Link)`
  width: 100%;
  min-height: 100px;
  border-bottom: 1px solid var(--ud-greyeb);
  padding: 0px 15px;
  color: black;
  display: block;
  .supportPage__listItemQuestion {
    padding: 13px 0px 9px 0px;
    font-weight: bold;
    font-size: 16px;
    cursor: pointer;
    text-decoration: none;
    width: 100%;
    display: flex;
    align-items: center;
    color: black;
    svg {
      margin-right: 15px;
    }
  }
  > span {
    font-weight: normal;
    font-size: 14px;
    color: #3c3c3c;
    line-height: 20px;
  }
  &:hover {
    .supportPage__listItemQuestion {
      text-decoration: underline;
    }
  }

  .supportPage__listItemPreview {
    font-weight: normal;
    font-size: 14px;
    color: var(--ud-grey3c);
    margin: 0px 0px 15px 0px;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
`

const pageLimit = 5

const Questions = ({ t, questionList, offset = 0, location, locale }) => {
  if (questionList && !_.isEmpty(questionList)) {
    const questions = questionList
      .slice(offset, offset + pageLimit)
      .map(faq => (
        <SupportPageListItem key={faq.id} to={`/${locale}/faq/${faq.id}`}>
          <div className="supportPage__listItemQuestion">
            <Icon path={mdiEarth} size={0.5} />
            <span dangerouslySetInnerHTML={{ __html: `${faq.title}` }} />
          </div>
          <span dangerouslySetInnerHTML={{ __html: `${faq.preview}` }} />
        </SupportPageListItem>
      ))
    return <SupportPageList>{questions}</SupportPageList>
  }
  return (
    <SupportPageList>
      <span>{t("no_data_available")}</span>
    </SupportPageList>
  )
}

export default ({ data, pageContext, location }) => {
  const {
    faqList,
    currentPage,
    totalPages,
    nextPage,
    prevPage,
    locale,
    googleFaqJson,
    currentBaseUrl,
    isLastPage,
    isFirstPage,
  } = pageContext
  const { t } = useTranslation()

  // const isFirst = currentPage === 1
  // const isLast = currentPage === totalPages
  const offset = (currentPage - 1) * pageLimit

  return (
    <Container>
      <SEO />
      {googleFaqJson && (
        <Helmet>
          <script type="application/ld+json">{`${JSON.stringify(
            googleFaqJson
          )}`}</script>
        </Helmet>
      )}
      <Questions
        t={t}
        questionList={faqList}
        location={location}
        locale={locale}
        offset={offset}
      />
      <Pagination
        currentBaseUrl={currentBaseUrl}
        isFirst={isFirstPage}
        isLast={isLastPage}
        prevPage={prevPage}
        nextPage={nextPage}
        totalPages={totalPages}
        locale={locale}
        currentPage={currentPage}
      />
    </Container>
  )
}
